export var IndustryType;
(function (IndustryType) {
    IndustryType["Ministry"] = "Ministry";
    IndustryType["Municipality"] = "Municipality";
    IndustryType["Private"] = "Private";
})(IndustryType || (IndustryType = {}));
export const IndustryTypeMapping = new Map([
    [IndustryType.Ministry, 'Ministry'],
    [IndustryType.Municipality, 'Municipality'],
    [IndustryType.Private, 'Private']
]);
